import React from 'react';

const StudentForm = ({ form, formError, classOptions, sectionOptions, onChange, onSubmit, onCancel, isEdit }) => (
  <form onSubmit={onSubmit} className="modal-form">
    <input type="text" placeholder="Name" value={form.name} onChange={e=>onChange('name', e.target.value)} required />
    <input type="date" placeholder="DOB" value={form.dob} onChange={e=>onChange('dob', e.target.value)} required />
    <select value={form.gender} onChange={e=>onChange('gender', e.target.value)} required>
      <option value="" disabled>Gender</option>
      <option value="Male">Male</option>
      <option value="Female">Female</option>
      <option value="Other">Other</option>
    </select>
    <select value={form.class} onChange={e=>onChange('class', e.target.value)} required>
      <option value="" disabled>Class</option>
      {(classOptions || []).map(opt => <option key={opt} value={opt}>{opt}</option>)}
    </select>
    <select value={form.section} onChange={e=>onChange('section', e.target.value)} required>
      <option value="" disabled>Section</option>
      {(sectionOptions || []).map(opt => <option key={opt} value={opt}>{opt}</option>)}
    </select>
    <input type="text" placeholder="Roll Number" value={form.rollNumber} onChange={e=>onChange('rollNumber', e.target.value)} />
    <input type="text" placeholder="Guardian Name" value={form.guardianName} onChange={e=>onChange('guardianName', e.target.value)} />
    <input type="text" placeholder="Guardian Phone" value={form.guardianPhone} onChange={e=>onChange('guardianPhone', e.target.value)} />
    <input type="date" placeholder="Admission Date" value={form.admissionDate} onChange={e=>onChange('admissionDate', e.target.value)} />
    <div className="modal-actions">
      <button type="submit">{isEdit ? 'Save' : 'Add'}</button>
      <button type="button" onClick={onCancel}>Cancel</button>
    </div>
    {formError && <div className="error">{formError}</div>}
  </form>
);

export default StudentForm; 